import { useContext } from 'react';
import axios from 'axios';
import { useQuery } from 'react-query';
import { Stack } from '../../shared/layouts';
import Header from '../../shared/Header';
import UserSection from './UserSection';
import AuthSection from './AuthSection';
import ExtraUsersSection from './ExtraUsersSection';
import Loader from '../../shared/Loader';
import WhiteLabelContext from '../../../context/WhiteLabelContext';
import AccountManagementSection from './AccountManagementSection';
import {useTranslation} from "react-i18next";
import ScanToLoginUwkluisApp from "./ScanToLoginUwkluisApp";
import UserContext from "../../../context/UserContext";
import useIconLibrary from "../../../hooks/useIconLibrary";

const SettingsPage = () => {
  const { t } = useTranslation();
  const { isRedLabel, appSettings, forceMfa } = useContext(WhiteLabelContext);
  const { user } = useContext(UserContext);
  const {
    isLoading,
    data = {},
    refetch,
  } = useQuery('settingData', async () => {
    const { data } = await axios.get('/user/settings/data', {
      headers: { 'Content-Type': 'application/json' },
    });
    return data;
  });
  const { SettingsIcon } = useIconLibrary();

  return (
    <Stack space="xl" width={{ sm: 656, ml: 672, lg: 800, xl: 1024 }}>
      {isLoading && <Loader />}
      <Header
        title={t("Instellingen")}
        icon={<SettingsIcon width="2rem" height="2rem" />}
        variant="page"
      />
      <UserSection
        fullName={data.full_name}
        email={data.current_email}
        language={data?.language}
      />
      {appSettings?.enableGenericApp && !user?.business_account && <ScanToLoginUwkluisApp/>}
      <AuthSection hideMfaTrashIcon={forceMfa} data={data?.mfas} refetchData={refetch} />

      {data.main_consumer_logged_in && <ExtraUsersSection uuid={data.uuid} />}
      {isRedLabel && <AccountManagementSection />}
    </Stack>
  );
};

export default SettingsPage;
